import { useContext, useEffect } from "react";
import { SnackbarContext } from "../../components/DesignSystem/Snackbars/SnackbarProvider";
import {
	SnackbarType,
	SNACKBAR_COMPONENTS
} from "../../components/DesignSystem/Snackbars/Snackbar_EN";

// Timeout constants
export const SHORT_TIMEOUT_IN_MS = 2000;
export const MEDIUM_TIMEOUT_IN_MS = 5000;
export const LONG_TIMEOUT_IN_MS = 8000;

export const useSnackbar = () => {
	const context = useContext(SnackbarContext);

	if (!context) {
		throw new Error("useSnackbar must be used within a SnackbarProvider");
	}

	useEffect(() => {
		console.log(`Context Changed.`);
	}, [context]);

	const { showSnackbar, hideSnackbar } = context;

	const showSnack = (
		type: SnackbarType,
		theme: "light" | "dark" = "dark",
		duration: number = MEDIUM_TIMEOUT_IN_MS
	) => {
		const component = SNACKBAR_COMPONENTS[type];

		if (!component) {
			console.error(`Snackbar component "${type}" not found`);
			return;
		}

		showSnackbar({
			id: `${type}-${Date.now()}`,
			component,
			theme,
			duration
		});
	};

	return {
		showSnack,
		hideSnackbar
	};
};
